import { render } from "./HeaderTable.vue?vue&type=template&id=10c85fc2&scoped=true"
import script from "./HeaderTable.vue?vue&type=script&lang=js"
export * from "./HeaderTable.vue?vue&type=script&lang=js"

import "./HeaderTable.vue?vue&type=style&index=0&id=10c85fc2&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10c85fc2"]])

export default __exports__